import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { history } from './../_helpers/history';
import { useLocation, useNavigate } from "react-router-dom";
import { IProduct } from "../models/product/IProduct";
import useWindowDimensions from "../_helpers/windiws.dimensions";
import { IMAGE } from "../constants/endpoints";

export interface IProductsSectionProps {
    products: IProduct[]
}
export default function ProductsSection(props: IProductsSectionProps) {

    history.navigate = useNavigate();
    history.location = useLocation();
    const { width } = useWindowDimensions();

    return (
        <>
            {
                props.products &&
                <Row>
                    {props.products.map((p: IProduct) => (
                        <Col lg={3} md={4} sm={6} xs={6} style={{ padding: "2px" }} key={p.id}>
                            <Card className="product-card" key={p.id} id={`${p.id}`} onClick={() => history.navigate(`/Product/${p.id}`)}>
                                <Card.Img className="product-card-img"
                                    src={`/api/${IMAGE}?id=${p.images[0]}`}></Card.Img>
                                <Card.Body>
                                    <Card.Title>
                                        {p.name}
                                    </Card.Title>
                                    {width > 575 && (<Card.Text>
                                        <p className="card-description adaptive-font-size">{p.shortDescription}</p>
                                    </Card.Text>)}
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            }
        </>
    )
}